// ----------------------------------------------------------------------

const PASTEL_COLORS = [
  { bg: '#C8E6C9', text: '#2E7D32' }, // sage green
  { bg: '#B3E5FC', text: '#0277BD' }, // soft blue
  { bg: '#D1C4E9', text: '#5E35B1' }, // lavender
  { bg: '#FFE0B2', text: '#E65100' }, // peach
  { bg: '#F8BBD0', text: '#AD1457' }, // blush pink
  { bg: '#B2DFDB', text: '#00695C' }, // mint
  { bg: '#FFCCBC', text: '#BF360C' }, // coral
  { bg: '#C5CAE9', text: '#283593' }, // periwinkle
];

function getInitials(name) {
  if (!name) return '';
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) {
    return (
      parts[0].charAt(0) + parts[parts.length - 1].charAt(0)
    ).toUpperCase();
  }
  return parts[0].charAt(0).toUpperCase();
}

function getAvatarColor(name) {
  if (!name) return PASTEL_COLORS[0];
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return PASTEL_COLORS[Math.abs(hash) % PASTEL_COLORS.length];
}

export default function createAvatar(name) {
  return {
    name: getInitials(name),
    color: getAvatarColor(name),
  };
}
